export const codeSnippets = [
    {id:1, textKey:"expressions.conditional_expression", body:"CASE\n      WHEN COUNTRYID=1 THEN 'ASIA'\n      WHEN COUNTRYID IN (2, 3, 4, 5) THEN 'EUROPE'\n      ELSE 'OTHER'\n END", tooltip: ""},
    {id:2, text:""},
    {id:3, textKey: "expressions.aggregate_expression", body: "SUM(ISPINREQUESTSUCCESS) * 100 / SUM(ISPINREQUEST)", tooltip: ""}
  ];
